/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MakeupInputs */

const en_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makeup`)
};

const es_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maquillaje`)
};

const fr_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maquillage`)
};

const de_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make-up`)
};

const ja_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メイクアップ`)
};

const zh_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`彩妆`)
};

const ar_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكياج`)
};

const id_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosmetik`)
};

const it_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make-up`)
};

const ru_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Макияж`)
};

const pt_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maquiagem`)
};

const ko_val_makeup = /** @type {(inputs: Val_MakeupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메이크업`)
};

/**
* | output |
* | --- |
* | "Makeup" |
*
* @param {Val_MakeupInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_makeup = /** @type {((inputs?: Val_MakeupInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MakeupInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_makeup(inputs)
	if (locale === "es") return es_val_makeup(inputs)
	if (locale === "fr") return fr_val_makeup(inputs)
	if (locale === "de") return de_val_makeup(inputs)
	if (locale === "ja") return ja_val_makeup(inputs)
	if (locale === "zh") return zh_val_makeup(inputs)
	if (locale === "ar") return ar_val_makeup(inputs)
	if (locale === "id") return id_val_makeup(inputs)
	if (locale === "it") return it_val_makeup(inputs)
	if (locale === "ru") return ru_val_makeup(inputs)
	if (locale === "pt") return pt_val_makeup(inputs)
	return ko_val_makeup(inputs)
});